<script>
  export let label = "Password";
  export let id = "password";
  export let value = "";
  export let errMsgs = {};
  export let handleInput = () => {};
  export let enterEvent = () => {};
  let showPassword = false;

  function togglePassword() {
    showPassword = !showPassword;
    const passwordInputs = document.querySelectorAll("input[id*='assword']");
    passwordInputs.forEach((input) => {
      input.type = showPassword ? "text" : "password";
    });
  }

  // trigger enterEvent if the user presses enter on an input field
  function handleKeyDown(event) {
    if (event.key === "Enter") {
      enterEvent();
    }
  }
</script>

<label for={id}>{label}</label>

{#if id.includes("password")}
  <div class="password-container">
    <!-- set the input to be disabled if the disabled prop is true -->
    <input
      type="password"
      {id}
      bind:value
      required
      on:input={handleInput(id)}
      class:error-input={errMsgs[id]}
      class:input-with-icon-right={!id.includes("Confirm")}
      on:keydown={handleKeyDown} />
    {#if !id.includes("Confirm")}
      <button class="show-password-button" on:click|preventDefault={togglePassword}>
        <img src={showPassword ? "/icons/eye-slash-solid.svg" : "/icons/eye-solid.svg"} />
      </button>
    {/if}
  </div>
{:else}
  <input type="text" {id} bind:value required on:input={handleInput(id)} class:error-input={errMsgs[id]} on:keydown={handleKeyDown} />
{/if}
{#if errMsgs[id]}
  <div class="error-message-input">{errMsgs[id]}</div>
{/if}

<style>
  .password-container {
    position: relative;
  }
  input {
    width: 100%;
    padding-right: 40px;
  }
  .show-password-button {
    width: 3.2em;
    height: 3.2em;
    position: absolute;
    top: 5%;
    transform: translateY(-50%);
    right: 0px;
    border: none;
    color: #fff;
    background-color: transparent;
    cursor: pointer;
    filter: invert(50%);
  }
  .show-password-button:hover {
    filter: invert(40%);
    background-color: transparent;
  }
  .input-with-icon-right {
    padding-right: 40px !important;
  }
</style>
